<template>
    <div id="subject-choose">
        <headers :title="titles"></headers>
        <template v-if="loading">
            <ul class="content"
                v-if='Subject.length'>
                <li @click="toSubject(11,1)"
                    v-if='Subject[0][11] == 11 && Subject.length'>
                    <img src="./img/sf_subject.png" />
                    <span>爱尚书法</span>
                </li>
                <li @click="toSubject(12,1)"
                    v-if='Subject[0][12] == 12 && Subject.length'>
                    <img src="./img/bc_subject.png" />
                    <span>爱尚编程</span>
                </li>
                <li @click="toSubject(13,1)"
                    v-if='Subject[0][13] == 13 && Subject.length'>
                    <img src="./img/mx_subject.png" />
                    <span>爱尚模型</span>
                </li>
            </ul>
            <p class="tips">目前仅支持素质E站学科的作业发布，如果您需要发布其他学科作业，请使用同步课堂APP</p>
        </template>
        <loadingS v-else></loadingS>
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'SRC/components/base/header.vue';
import loadingS from 'SRC/components/base/tealoading.vue';

export default {
    data () {
        return {
            isInspect: this.$route.query.type,//区分发作业还是检查作业
            titles: '选择学科',
            unitList: {},
            Subject: [],
            loading: true,
            token: localStorage.getItem('Tbkt-Token'),
            is_show: 0, // 激活活动 
            type: 0, // 激活活动 
        }
    },
    computed: {},
    watch: {},
    methods: {
        toSubject (sub, type) {
            let url = `/qualityStation/choosetype/${sub}`
            this.toJump(url, type)
        },
        toJump (url, type) {
            this.$router.push(`${url}?type=1&user_type=${this.type}&is_show=${this.is_show}`)
        },
    },
    components: {
        headers, loadingS
    },
    mounted () {

    },
    async created () {
        let sub = {};

        await this.$http.post(API_URL_BASE_API + '/account/profile/').then((res) => {
            if (res.data.response === 'ok') {
                let r = res.data.data;
                localStorage.setItem('info', JSON.stringify(r));
                this.$store.commit('setinfo', r);
                r.units.forEach((m, n) => {
                    if (!sub[m.sid]) {
                        sub[m.sid] = m.sid
                    }
                });
                this.Subject.push(sub);
                if (Object.keys(sub).length === 1) {
                    this.toSubject(parseInt(Object.keys(sub)[0]), 2)
                } else {
                    this.loading = true;
                }
                //把老师所带的科目数存到本地
                localStorage.setItem('subjectLength', Object.keys(this.Subject[0]).length);
            }
        });
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

#subject-choose {
    min-height: 100vh;
    .header {
        background: #5e89ef;
        .left {
            display: block;
            width: 18px / $ppr;
            height: 34px / $ppr;
            background: url("./img/subject_choose_back.png") 0 0 no-repeat;
            background-size: 100% 100%;
        }
    }
    .img {
        width: 100%;
        height: 200px / $ppr;
        img {
            position: fixed;
            top: 96px / $ppr;
            left: 0;
            right: 0;
            width: 100%;
            display: block;
            height: 200px / $ppr;
            z-index: 8;
        }
    }
    .content {
        padding: 0 24px / $ppr 50px / $ppr;
        li {
            margin-top: 32px / $ppr;
            height: 168px / $ppr;
            line-height: 168px / $ppr;
            background: #fff;
            border-radius: 10px / $ppr;
            img {
                margin-left: 24px / $ppr;
                width: 104px / $ppr;
                height: 104px / $ppr;
                vertical-align: middle;
            }
            span {
                margin-left: 32px / $ppr;
                color: #333;
                font-size: 36px / $ppr;
            }
        }
    }
    .tips {
        font-size: 24px / $ppr;
        padding: 20px / $ppr 50px / $ppr;
        color: #999;
        line-height: 2;
    }
}
</style>
